import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
// =====================================================
// Fade in "Nos Valeurs"
// =====================================================
(() => {
  const valeurs = gsap.utils.toArray('.valeur');
  valeurs.forEach((element, i) => {
    const anim = gsap.fromTo(
      element,
      { autoAlpha: 0, xPercent: 30 },
      { duration: 1, autoAlpha: 1, xPercent: 0, ease: 'power1.out' },
    );
    ScrollTrigger.create({ trigger: element, animation: anim, toggleActions: 'play none none none', once: true });
  });
})();
